import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { Message } from 'src/app/core/class/message';
import { Common } from 'src/app/core/constants/common';
import { isUndefined } from 'util';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html'
})
export class BaseComponent implements OnInit {
  isEnLanguage = true;

  emailPattern = Common.EMAIL_PATTERN;
  emailMaxlength = Common.EMAIL_MAXLENGTH;

  phonePattern = Common.PHONE_PATTERN;
  phonePattern2 = Common.PHONE_PATTERN2;
  phoneMaxlength = Common.PHONE_MAXLENGTH;

  certificateNoPattern = Common.CERTIFICATE_NO_PATTERN;

  taxCodeMaxlength = Common.TAX_CODE_MAXLENGTH;

  accountNumberMaxlength = Common.ACCOUNT_NUMBER_MAXLENGTH;

  accountNameMaxlength = Common.ACCOUNT_NAME_MAXLENGTH;

  branchNameMaxlength = Common.BRANCH_NAME_MAXLENGTH;

  bankMaxlength = Common.BANK_MAXLENGTH;

  documentCodePattern = Common.DOCUMENT_CODE_PATTERN;

  descriptPattern = Common.DESCRIPT_PATTERN;

  phoneMaxlength2 = Common.MAX_LENGTH_PHONE
  constructor(
    public commonService: CommonService,
    public message: Message
  ) { }

  ngOnInit() {
  }

  getCities() {
    return this.commonService.getAllCity();
  }

  getDistricts() {
    return this.commonService.getAllDistricts();
  }

  getWards() {
    return this.commonService.getAllWard();
  }

  getCitiesRedis() {
    return this.commonService.getAllCityRedis();
  }

  getDistrictsRedis() {
    return this.commonService.getAllDistrictsRedis();
  }

  getWardsRedis() {
    return this.commonService.getAllWardRedis();
  }

  setLanguagelocalStored(newLanguge: string) {
    localStorage.setItem('__language', newLanguge);
  }

  getLanguagelocalStored() {
    return localStorage.getItem('__language');
  }

  checkIconLanguage(language: string) {
    if (language === 'en') {
      this.isEnLanguage = true;
    } else {
      this.isEnLanguage = false;
    }
  }

  /**
   * Get error from date
   */
  getErrorDateMessage(pickerInput: string, isExpired?: boolean): string {
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage(isExpired ? 'validation.date_format_doc' : 'validation.date_format');
  }

  /**
   * (1)	Kiểm tra cấu trúc mã 10 số:
   * Số A = 31*số đầu tiên bên trái
   * + 29*số thứ 2 + 23*số thứ 3
   * + 19*số thứ 4 + 17*số thứ 5
   *  + 13*số thứ 6 + 7* số thứ 7
   *  + 5*số thứ 8+3*số thứ 9.
   * Lấy số A chia cho 11 lấy phần dư là số B,
   *  lấy 10 trừ số B bằng số thứ 10 trong mã số thuế là đúng,
   *  ngược lại là sai.
   * (2)	Kiểm tra cấu trúc mã 13 số: bao gồm việc kiểm tra cấu trúc mã 10 số và kiểm tra giá trị của 3 số cuối.
   * Ba số cuối phải được nhập đầy đủ.
   * @param taxCode The tax code.
   */
  public validateTaxcode(taxCode: string) {
    if (!taxCode) {
      return false;
    }

    let tempTaxCode = taxCode.trim();

    if (tempTaxCode.length < 10 || tempTaxCode.length > 14) {
      return false;
    }

    // - must start from 10 - 13.
    if (tempTaxCode.indexOf('-') < 10 && tempTaxCode.indexOf('-') >= 0) {
      return false;
    }

    // replace - by "".
    tempTaxCode = tempTaxCode.replace('-', '');

    const firstCode = tempTaxCode.substring(0, 10).trim();
    if (firstCode.length < 10) {
      return false;
    }

    let secondCode = '';
    if (tempTaxCode.length > 10) {
      secondCode = tempTaxCode.substring(10).trim();
    }

    // string to array of numbers.
    const firstCodeArr = tempTaxCode.split('');

    let a =
      // 31*số đầu tiên bên trái
      Number(firstCodeArr[0]) * 31
      // 29*số thứ 2
      + Number(firstCodeArr[1]) * 29
      // 23*số thứ 3
      + Number(firstCodeArr[2]) * 23
      // 19*số thứ 4
      + Number(firstCodeArr[3]) * 19
      // 17*số thứ 5
      + Number(firstCodeArr[4]) * 17
      // 13*số thứ 6
      + Number(firstCodeArr[5]) * 13
      // 7* số thứ 7
      + Number(firstCodeArr[6]) * 7
      // 5*số thứ 8
      + Number(firstCodeArr[7]) * 5
      // 3*số thứ 9.
      + Number(firstCodeArr[8]) * 3;

    // Lấy số A chia cho 11 lấy phần dư là số B,
    const b = a % 11;
    if (10 - b !== Number(firstCodeArr[9])) {
      return false;
    }

    // not exist second code.
    if (secondCode.length === 0 && taxCode.indexOf('-')  <= 0) { return true; }
    if (secondCode.length === 3 && taxCode.indexOf('-') > 0) {
      const secondCodeArr = secondCode.split('');
      a =  Number(secondCodeArr[0]) + Number(secondCodeArr[1]) + Number(secondCodeArr[2]);
      if (isNaN(a) || isUndefined(a)) {
        return false;
      }
    } else {
      return false;
    }

    return true;
  }
}
